export const isAllHtmlElements = (a: Array<unknown>): a is Array<HTMLElement> => {
  return a.every((el) => el instanceof HTMLElement);
};
